import React from 'react';
import {
  Box,
  Heading,
  Text,
  Flex,
  Button,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import { Zap, Plus } from 'lucide-react';
import Page from '../../layout/IntegraAppPage';
import AutomacaoModal from '../../components/Modals/AutomacaoModal/AutomacaoModal';

const Configuracoes = () => {
  const corDeFundo = useColorModeValue('white', 'gray.800');
  const corDaBorda = useColorModeValue('gray.200', 'gray.700');
  const corTextoSecundario = useColorModeValue('gray.500', 'gray.400');

  const modalAutomacao = useDisclosure();
  const canalSelecionado = null;

  return (
    <Page>
      {/* Cabeçalho da Automação */}
      <Flex mb={6} justify="space-between" align="flex-end">
        <Box>
          <Heading size="lg">Automação</Heading>
          <Text fontSize="sm" color={corTextoSecundario}>
            Configure automações para otimizar seus processos
          </Text>
        </Box>

        <Button
          leftIcon={<Plus size={18} />}
          colorScheme="blue"
          onClick={modalAutomacao.onOpen}
        >
          Nova automação
        </Button>
      </Flex>

      {/* flex das 2 colunas */}
      <Flex gap={6} align="stretch">
        {/* box esquerda */}
        <Box
          flex="1"
          bg={corDeFundo}
          border="1px solid"
          borderColor={corDaBorda}
          borderRadius="2xl"
          minH="300px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          p={6}
        >
          <Flex direction="column" align="center" gap={3}>
            <Zap size={40} color="gray" />
            <Text fontWeight="500">Selecione uma automação</Text>
            <Text
              fontSize="sm"
              color={corTextoSecundario}
              textAlign="center"
              maxW="300px"
            >
              Escolha uma automação ao lado para visualizar detalhes ou clique
              em + Nova automação
            </Text>
          </Flex>
        </Box>

        {/* box direita */}
        <Box flex="1" p={4} display="flex" flexDirection="column">
          <Heading size="md" mb={4}>
            {' '}
            Automações{' '}
          </Heading>

          {/* direita */}
          <Box p={4} borderRadius="lg">
            <Text fontSize="xs" align="center" color="gray.400">
              Automaçôes Criadas...
            </Text>
          </Box>
        </Box>
      </Flex>

      {/* modal */}
      <AutomacaoModal
        isOpen={modalAutomacao.isOpen}
        onClose={modalAutomacao.onClose}
        data={canalSelecionado}
      />
    </Page>
  );
};

export default Configuracoes;
